import { useState } from "react";

import { useMediaQuery } from "react-responsive";

import { Box, Flex } from "@/components/layout/flexbox";
import { isXsQuery } from "@/components/layout/Media";
import { FadeInBox } from "@/components/pieces/FadeInBox";
import { ConfirmMessage } from "@/components/pieces/onboarding/ConfirmMessage";
import { OptionCard } from "@/components/pieces/onboarding/OptionCard";
import { PageTitle } from "@/components/pieces/onboarding/PageTitle";
import { SUBTEXT_COLOR } from "@/css/constants";

interface OptionType {
  id: string;
  name: string;
  description?: string | null;
  iconUrl?: string | null;
}

interface MatchingCategoryComponentProps {
  loading?: boolean;
  description: string;
  initialSelectedIds?: string[];
  options: OptionType[];
  onSubmit: (selectedOptionIds: string[]) => void;
}

interface OptionProps {
  interactive: boolean;
  cardState?: "active" | "inactive";
  name: string;
  description?: string | null;
  onClick: () => void;
}

function Option({
  interactive,
  cardState,
  name,
  description,
  onClick,
}: OptionProps) {
  return (
    <Box px={2} my={3}>
      <OptionCard
        elevation={2}
        p={16}
        interactive={interactive}
        onClick={onClick}
        className={cardState}
        style={{ height: "100%" }}
      >
        <div>
          <b>{name}</b>
        </div>
        <Box color={SUBTEXT_COLOR} mt={1}>
          {description}
        </Box>
      </OptionCard>
    </Box>
  );
}

export function SingleChoice({
  description,
  options,
  onSubmit,
}: MatchingCategoryComponentProps) {
  const [seletecOptionId, setSelectedOptionId] = useState<string>();

  function handleSelect(optionId: string) {
    setSelectedOptionId(optionId);
    setTimeout(() => {
      onSubmit([optionId]);
    }, 1500);
  }

  const saving = seletecOptionId !== undefined;
  const isXs = useMediaQuery(isXsQuery);

  return (
    <Flex justifyContent="center">
      <Box width={[1, 600]} style={{ fontSize: isXs ? 16 : 18 }}>
        <FadeInBox>
          <PageTitle
            title={description}
            style={{
              textAlign: "center",
            }}
          />
          <Box mx={-2} style={{ overflow: "hidden", padding: "0 16px 16px" }}>
            {options.map((option) => {
              const active = option.id === seletecOptionId;
              const interactive = !active && !saving;
              return (
                <Option
                  key={option.id}
                  interactive={interactive}
                  cardState={
                    active ? "active" : seletecOptionId ? "inactive" : undefined
                  }
                  name={option.name}
                  description={option.description}
                  onClick={() =>
                    interactive ? handleSelect(option.id) : undefined
                  }
                />
              );
            })}
          </Box>
          <ConfirmMessage visible={saving} message="👌 Got it" />
        </FadeInBox>
      </Box>
    </Flex>
  );
}
